(function($, Drupal, window, document) {
  'use strict';

  Drupal.behaviors.ctaWithTabsAndFacts = {
    attach: function(context, settings) {
      if (typeof context['location'] !== 'undefined') { // Only fire on document load.

        // Hide all cta tab contents by default
        $('.cta-with-tabs--tab-content').hide();

        // When page initially loads, only show the default active tab
        var id = $('.cta-with-tabs--tab-button.active').attr('id').match(/(\d+)/)[0];
        $(`#cta-tab-content--${id}`).show();

        // On tab click...
        $('.cta-with-tabs--tab-button').click((event) => {
          // Grab the id from the tab clicked
          let idTarget = $(event.target).attr('id').match(/(\d+)/)[0];

          // Remove active class from the current active tab and hide all tab contents again
          $('.cta-with-tabs--tab-button').removeClass('active');
          $(`[id^=cta-tab-content--]`).hide();

          // Add the active class to the clicked tab and show it's corresponsding tab content
          $(event.target).addClass('active');
          $(`#cta-tab-content--${idTarget}`).show();
        });
      }
    }
  };

})(jQuery, Drupal, window, document);
